import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';
import { ScrollButton } from './ui/ScrollButton';
export const ContrastTable = () => {
  const badPoints = ['Mandás presupuestos y silencio total', 'Cuando te dicen "no tengo plata" no sabés qué responder', 'Tus clientes dicen "dejame pensarlo" y desaparecen', 'Bajás el precio cada vez que sienten resistencia'];
  const goodPoints = ['Tus propuestas generan respuesta en 48 hs', 'Tenés un guion probado para cada objeción', 'Sabés exactamente qué decir para que decidan', 'Justificás el valor y cerrás sin descuentos'];
  return <section className="py-24 bg-cream" data-id="element-67">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-68">
        <div className="text-center mb-16" data-id="element-69">
          <h2 className="text-3xl sm:text-4xl font-bold text-neutral-900 mb-4" data-id="element-70">
            Lo que está pasando hoy vs. lo que debería estar pasando
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-71">
          {/* Bad Column */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-xl p-6 sm:p-8 border border-neutral-200 shadow-sm" data-id="element-72">
            <div className="flex items-center gap-3 mb-8 pb-4 border-b border-neutral-100" data-id="element-73">
              <XCircle className="w-8 h-8 text-neutral-400" data-id="element-74" />
              <h3 className="text-2xl font-bold text-neutral-700" data-id="element-75">
                HOY (Sin el sistema)
              </h3>
            </div>
            <ul className="space-y-6" data-id="element-76">
              {badPoints.map((point, i) => <li key={i} className="flex items-start gap-3 text-neutral-600" data-id="element-77">
                  <span className="text-neutral-400 mt-1" data-id="element-78">❌</span>
                  <span className="text-lg leading-snug" data-id="element-79">{point}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Good Column */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-brand-600 rounded-xl p-6 sm:p-8 shadow-md" data-id="element-80">
            <div className="flex items-center gap-3 mb-8 pb-4 border-b border-brand-500/50" data-id="element-81">
              <CheckCircle2 className="w-8 h-8 text-white" data-id="element-82" />
              <h3 className="text-2xl font-bold text-white" data-id="element-83">
                CON CAJA DE COBRO
              </h3>
            </div>
            <ul className="space-y-6" data-id="element-84">
              {goodPoints.map((point, i) => <li key={i} className="flex items-start gap-3 text-brand-50" data-id="element-85">
                  <span className="text-white mt-1" data-id="element-86">✅</span>
                  <span className="text-lg font-medium leading-snug" data-id="element-87">
                    {point}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-2xl mx-auto" data-id="element-88">
          <ScrollButton className="w-full sm:w-auto" data-id="element-89">
            QUIERO DEJAR DE PERDER VENTAS →
          </ScrollButton>
        </motion.div>
      </div>
    </section>;
};